import { render, staticRenderFns } from "./PasswordResetSendMail.vue?vue&type=template&id=48ff76db&scoped=true&"
import script from "./PasswordResetSendMail.vue?vue&type=script&lang=js&"
export * from "./PasswordResetSendMail.vue?vue&type=script&lang=js&"
import style0 from "./PasswordResetSendMail.vue?vue&type=style&index=0&id=48ff76db&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48ff76db",
  null
  
)

export default component.exports